<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import SidebarUnreadBadge from './SidebarUnreadBadge.vue';
import { getInboxColor } from 'dashboard/helper/inboxColor';
import { isSessionProvider } from 'dashboard/helper/whatsappSession';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
  inbox: {
    type: Object,
    required: true,
  },
  badgeCount: {
    type: [Number, String],
    default: 0,
  },
});

const reauthorizationRequired = computed(() => {
  return props.inbox.reauthorization_required;
});

const isWhatsappSession = computed(() =>
  isSessionProvider(props.inbox.provider)
);

const dotColor = computed(() => getInboxColor(props.inbox));
</script>

<template>
  <span class="size-4 grid flex-shrink-0 place-content-center">
    <span
      class="size-2.5 rounded-full"
      data-test-id="channel-dot"
      :style="{ backgroundColor: dotColor }"
    />
  </span>
  <div
    class="flex-1 truncate min-w-0"
    data-test-id="channel-leaf-label"
    :title="label"
  >
    {{ label }}
  </div>
  <SidebarUnreadBadge :count="badgeCount" :active="active" />
  <div
    v-if="reauthorizationRequired"
    v-tooltip.top-end="
      isWhatsappSession
        ? $t('SIDEBAR.WHATSAPP_DISCONNECTED')
        : $t('SIDEBAR.REAUTHORIZE')
    "
    data-test-id="reauthorization-alert"
    class="grid place-content-center size-5 bg-n-ruby-5/60 rounded-full"
  >
    <Icon icon="i-woot-alert" class="size-3 text-n-ruby-9" />
  </div>
</template>
